export default __webpack_public_path__ + "static/media/plastic-free.b6e8557f.svg";